import { planoNome } from "../../../utils/constants";
import { setMycoinsInitialConfig } from "./mycoinsConfig";
import getDescontoParaPlano from "../../../utils/compararDescontos";

export const createSelectedPlan = (planoID, bemId, options, setConsorcioStore) => {
  const selectedOption = options
    .filter((option) =>
      option.planosTipos.map((plano) => plano.planoID).includes(planoID)
    )
    .filter((option) =>
      option.planosTipos.map((plano) => plano.bemId).includes(bemId)
    )[0];

  const userSelectedPlan = options
    .map((plan) => plan.planosTipos)
    .flat()
    .find((plan) => plan.planoID === planoID && plan.bemId === bemId);

  const desconto = getDescontoParaPlano(userSelectedPlan);

  const selectedPlano = {
    nome: userSelectedPlan.name,
    planoIndex: 0,
    planoID: userSelectedPlan.planoID,
    bemID: userSelectedPlan.bemId,
    bemNome: userSelectedPlan.bemNome,
    bemCredito: selectedOption.bemValor,
    planoMeses: selectedOption.planoMeses,
    grupo: userSelectedPlan.grupo,
    planoValorParcela: userSelectedPlan.valorParcela,
    planoValorPagamento: desconto
      ? desconto.valorPrimeiraParcelaComDesconto
      : userSelectedPlan.valorParcelaPrimeiroPagto,
    planoValorPagamentoBruto: userSelectedPlan.valorParcelaPrimeiroPagto,
    labelPlano: "",
    imagemUrlPlano: "",
    exibirTextoResolucao285: userSelectedPlan.exibirTextoResolucao285,
    dataAssembleia: userSelectedPlan.dataProximaAssembleia,
    tipoPlanoID: userSelectedPlan.tipoPlanoID,
    planoTaxaAdmMensal: userSelectedPlan.planoTaxaAdmMensal,
    planoTaxaAdmTotal: userSelectedPlan.planoTaxaAdmTotal,
    valorPremioSeguro: userSelectedPlan.valorPremioSeguro || 0,
    valorParcelaPrimeiroPagtoComSeguro: userSelectedPlan.valorParcelaPrimeiroPagtoComSeguro || 0,
    valorParcelaComSeguro: userSelectedPlan.valorParcelaComSeguro || 0,
  };

  setConsorcioStore(planoNome[selectedPlano.nome], "tipoPlano");
  setMycoinsInitialConfig(selectedPlano);

  return selectedPlano;
};
